export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-cream-border bg-cream-light">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-4xl text-forest leading-none">Golf Start</div>
          <p className="mt-5 text-forest-muted max-w-md font-light leading-relaxed">
            An editorial coaching marketplace for players of all levels. Find an experienced pro, book an hour,
            and see your game improve — beginner, intermediate, advanced, junior or adult.
          </p>
        </div>
        <div>
          <div className="eyebrow">Explore</div>
          <ul className="mt-5 space-y-3 text-sm text-forest-dark">
            <li>Browse Coaches</li>
            <li>How It Works</li>
            <li>Gift Lessons</li>
            <li>For Coaches</li>
          </ul>
        </div>
        <div>
          <div className="eyebrow">Contact</div>
          <ul className="mt-5 space-y-3 text-sm text-forest-dark">
            <li>hello@mygolfstart.com</li>
            <li>San Francisco, California</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream-border">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-forest-muted uppercase tracking-[0.2em]">
          <span>© 2026 Golf Start Collective</span>
          <span>Quiet. Precise. Played for life.</span>
        </div>
      </div>
    </footer>
  );
}
